import { defineComponent, computed } from "vue";
import { V as VaDropdown } from "../va-dropdown/index-8fef29c8.mjs";
import { e as extractComponentProps } from "../../utils/component-options/extract-component-options-6b96d215.mjs";
import { V as VaIcon } from "../va-icon/index-b0729838.mjs";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset-0dfbd395.mjs";
import { f as filterComponentProps } from "../../utils/component-options/filter-props-9727421a.mjs";
import { u as useColors } from "../../composables/useColors-6d98be99.mjs";
import { u as useTextColor } from "../../composables/useTextColor-d6b2d8c3.mjs";
const VaDropdownProps = extractComponentProps(VaDropdown, ["closeOnClickOutside"]);
const _sfc_main = defineComponent({
  name: "VaPopover",
  components: { VaDropdown, VaIcon },
  props: {
    ...VaDropdownProps,
    ...useComponentPresetProp,
    trigger: { default: "hover" },
    color: { type: String, default: "#1b1a1f" },
    // TODO: Make sure add this color to pallete
    textColor: { type: String },
    icon: { type: String, default: "" },
    title: { type: String, default: "" },
    message: { type: String, default: "" },
    autoHide: { type: Boolean, default: true },
    offset: { type: [Array, Number], default: 4 }
  },
  setup(props, { slots }) {
    const VaDropdownPropValues = filterComponentProps(VaDropdownProps);
    const { getColor, getBoxShadowColor } = useColors();
    const { textColorComputed } = useTextColor();
    const showIconComputed = computed(() => props.icon || slots.icon);
    const showTitleComputed = computed(() => props.title || slots.title);
    const showBodyComputed = computed(() => props.message || slots.body);
    const showPopoverContentComputed = computed(
      () => showTitleComputed.value || showBodyComputed.value
    );
    const computedPopoverStyle = computed(() => ({
      boxShadow: `var(--va-popover-content-box-shadow) ${getBoxShadowColor(getColor(props.color))}`,
      backgroundColor: getColor(props.color),
      color: textColorComputed.value
    }));
    return {
      textColorComputed,
      VaDropdownPropValues,
      showBodyComputed,
      showIconComputed,
      showTitleComputed,
      computedPopoverStyle,
      showPopoverContentComputed
    };
  }
});
export {
  _sfc_main as _
};

import '../../../VaPopover.css';
//# sourceMappingURL=VaPopover.vue_vue_type_script_lang-4c249a95.mjs.map
